import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "ui-component/Loadable";
import MainLayout from "layout/MainLayout";
import RoleProtected from "components/RoleProtected";
const RootRedirect = () => {
  const token = localStorage.getItem("token");
  const isValid = token && token !== "undefined" && token !== "null";
  return isValid ? <Navigate to="/dashboard" replace /> : <Navigate to="/auth/login" replace />;
};

const Dashboard = Loadable(lazy(() => import("views/dashboard/Default")));
const CafeList = Loadable(lazy(() => import("views/cafe/CafeList")));
const CafeDetails = Loadable(lazy(() => import("views/cafe/CafeDetails")));
const AddCafe=Loadable(lazy(()=>import("views/cafe/AddCafe")))
const EditCafe = Loadable(lazy(() => import("views/cafe/EditCafe")));
const KycList = Loadable(lazy(() => import("views/kyc/KycList")));
const KycDetails = Loadable(lazy(() => import("views/kyc/KycDetails")));
const InvestmentList = Loadable(lazy(() => import("views/investment/InvestmentList")));
const InvestmentDetails = Loadable(lazy(() => import("views/investment/InvestmentDetails")));
const ReferralEarnings = Loadable(lazy(() => import("views/referral/ReferralEarnings")));
// const ProfitDistribution = Loadable(lazy(() => import("views/referral/ProfitDistribution")));
const UserList = Loadable(lazy(() => import("views/users/UserList")));
const UserDetails = Loadable(lazy(() => import("views/users/UserDetails")));
const ContactList = Loadable(lazy(() => import("views/contact/ContactList")));
const RoleManagement = Loadable(lazy(() => import("views/role/RoleManagement")));
const RoleAssignment = Loadable(lazy(() => import("views/role/RoleAssignment")));
//const ShareList = Loadable(lazy(() => import("views/share/ShareList")));

const MainRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    {
      path: "/",
      // ✅ Dynamic redirect based on token
      element: <RootRedirect />
    },
    {
      path: "dashboard",
      element: <RoleProtected><Dashboard /></RoleProtected>,
    },
    {
      path: "cafe",
      element: <RoleProtected><CafeList /></RoleProtected>,
    },
    {
      path: "cafe/add",
      element: <RoleProtected><AddCafe /></RoleProtected>,
    },
    {
      path: "cafe/edit/:id",
      element: <RoleProtected><EditCafe /></RoleProtected>,
    },
    {
      path: "cafe/:id",
      element: <RoleProtected><CafeDetails /></RoleProtected>,
    },
    {
      path: "kyc",
      element: <RoleProtected><KycList /></RoleProtected>,
    },
    {
      path: "kyc/:userId",
      element: <RoleProtected><KycDetails /></RoleProtected>,
    },
    {
      path: "investment",
      element: <RoleProtected><InvestmentList /></RoleProtected>,
    },
    {
      path: "investment/:id",
      element: <RoleProtected><InvestmentDetails /></RoleProtected>,
    },
    {
      path: "referral",
      element: <RoleProtected><ReferralEarnings /></RoleProtected>,
    },
    // {
    //   path: "profit-distribution",
    //   element: <RoleProtected><ProfitDistribution /></RoleProtected>,
    // },
    {
      path: "users",
      element: <RoleProtected><UserList /></RoleProtected>,
    },
    {
      path: "users/:id",
      element: <RoleProtected><UserDetails /></RoleProtected>,
    },
    {
      path: "contacts",
      element: <RoleProtected><ContactList /></RoleProtected>,
    },
    {
      path: "roles",
      element: <RoleProtected><RoleManagement /></RoleProtected>,
    },
    {
      path: "roles/assignment",
      element: <RoleProtected><RoleAssignment /></RoleProtected>,
    },
    // {
    //   path: "shares",
    //   element: <RoleProtected><ShareList /></RoleProtected>,
    // },
    {
      path: "*",
      element: <Navigate to="/" replace />
    }
  ]
};

export default MainRoutes;